import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from "src/app/components/menu/navigator";
import { ConfigService } from 'src/app/services/config/config.service';


@Component({
  selector: 'app-popover-content',
  templateUrl: './popover-content.component.html',
  styleUrls: ['./popover-content.component.scss'],
})
export class PopoverContentComponent implements OnInit {

  public popOverContent: string;
  public popOverTitle;
  public logoutDismissTimer: number;
  public isMobileApp: boolean = false;

  constructor(
    public eventsService: EventsService,
    public config: ConfigService,
    public navigator: Navigator,
    public viewCtrl: ModalController,
    private platform: Platform,
  ) {
    this.logoutDismissTimer = !!this.config.getConfig().LOGOUT_DISMISS_TIMER ? this.config.getConfig().LOGOUT_DISMISS_TIMER : 2000000;
  }

  ngOnInit() {
    this.popOverTitle = 'Logout'
    this.popOverContent = this.navigator.activePopovers[this.navigator.activePopovers.length - 1].componentProps.data.message;
    setTimeout(() => this.closePopover(), this.logoutDismissTimer);
  }

  closePopover() {
    this.navigator.dismissAll();
    //const pageName = this.config.getExternalLinks().payload.filter(link => link?.code == "homepage")[0]?.url;
    return this.eventsService.publish('action:changeTab', 'casino');
  }


}
